export const SWAGMAGIC_BLOG_ROUTES = ["/blog/[...catchAll]", "/blog"];
